import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { sriLankaPaths } from './sriLankaPaths';
import { districtData } from '../../constants/districtData';

const SriLankaMap = ({ onDistrictHover }) => {
    const [hoveredDistrict, setHoveredDistrict] = useState(null);
    const [selectedDistrictId, setSelectedDistrictId] = useState('any');
    const navigate = useNavigate();

    // Notify parent of hover state changes
    useEffect(() => {
        if (onDistrictHover) {
            onDistrictHover(hoveredDistrict);
        }
    }, [hoveredDistrict, onDistrictHover]);

    const handleDistrictClick = (id) => {
        navigate(`/travel/district/${id}`);
    };

    const districts = ['Any', 'Colombo', 'Kandy', 'Galle', 'Ampara', 'Anuradhapura', 'Badulla', 'Batticaloa', 'Gampaha', 'Hambantota', 'Jaffna', 'Kalutara', 'Kegalle', 'Kilinochchi', 'Kurunegala', 'Mannar', 'Matale', 'Matara', 'Moneragala', 'Mullativu', 'Nuwara Eliya', 'Polonnaruwa', 'Puttalam', 'Ratnapura', 'Trincomalee', 'Vavuniya'];

    const handleDropdownChange = (e) => {
        const name = e.target.value;
        const id = name.toLowerCase().replace(/\s+/g, '-');
        setSelectedDistrictId(id);

        if (id !== 'any') {
            const data = districtData[id];
            const pathInfo = sriLankaPaths.find(p => p.id === id);
            if (pathInfo && data) {
                setHoveredDistrict({ ...pathInfo, ...data });
            }
        } else {
            setHoveredDistrict(null);
        }
    };

    return (
        <div className="relative w-full">
            {/* Dropdown Selector */}
            <div className="flex flex-col items-center mb-12">
                <span className="text-[10px] font-black text-emerald-600 uppercase tracking-[0.3em] mb-3">Quick Navigation</span>
                <div className="relative group">
                    <select
                        onChange={handleDropdownChange}
                        className="appearance-none bg-white border-2 border-slate-100 rounded-2xl px-12 py-4 pr-16 text-sm font-bold text-slate-900 focus:outline-none focus:border-emerald-500 transition-all cursor-pointer shadow-sm hover:shadow-md"
                    >
                        {districts.map(name => (
                            <option key={name} value={name}>{name === 'Any' ? 'Select District' : name}</option>
                        ))}
                    </select>
                    <div className="absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                    </div>
                </div>
            </div>

            <svg
                viewBox="0 0 25 40"
                className="w-full max-w-[450px] mx-auto h-auto drop-shadow-2xl"
                style={{ filter: 'drop-shadow(0 25px 25px rgba(0, 0, 0, 0.15))' }}
            >
                {sriLankaPaths.map((district) => {
                    const isHovered = hoveredDistrict?.id === district.id || selectedDistrictId === district.id;
                    const data = districtData[district.id];

                    return (
                        <g
                            key={district.id}
                            onMouseEnter={() => setHoveredDistrict({ ...district, ...data })}
                            onMouseLeave={() => !selectedDistrictId || selectedDistrictId === 'any' ? setHoveredDistrict(null) : null}
                            onClick={() => handleDistrictClick(district.id)}
                            className="cursor-pointer"
                        >
                            {district.paths.map((p, index) => (
                                <motion.path
                                    key={`${district.id}-${index}`}
                                    d={p}
                                    initial={{ fill: "#f1f5f9", stroke: "#e2e8f0" }}
                                    animate={{
                                        fill: isHovered ? "#10b981" : "#ffffff",
                                        stroke: isHovered ? "#059669" : "#cbd5e1",
                                        scale: isHovered ? 1.05 : 1,
                                    }}
                                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                    className="stroke-[0.15]"
                                />
                            ))}
                        </g>
                    );
                })}
            </svg>
        </div>
    );
};

export default SriLankaMap;
